export const CANVAS_HISTORY_REQUEST = "CANVAS_HISTORY_REQUEST";
export const CANVAS_HISTORY_SUCCESS = "CANVAS_HISTORY_SUCCESS";
export const CANVAS_HISTORY_FAILED = "CANVAS_HISTORY_FAILED";